import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";

// Correct import for Swiper 9.x
import SwiperCore, { Pagination } from "swiper";
SwiperCore.use([Pagination]);

const cardData = [
  {
    title: "Hello deposits.\nGoodbye no-shows.",
    subtitle:
      "Take secure online deposits or full payment with Lokalai. Reduce no-shows and cancellations by up to 60%.",
    image: "https://images.pexels.com/photos/3997377/pexels-photo-3997377.jpeg",
  },
  {
    title: "Use in-salon payments. Look pro.",
    subtitle:
      "Take professional, error-free card payments in-salon. The solution you’ve been searching for.",
    image: "https://images.pexels.com/photos/3997347/pexels-photo-3997347.jpeg",
  },
  {
    title: "Charge right the first time. Every time.",
    subtitle:
      "No more manually entering the amount to pay. No more painful end-of-day cash up and reconciliation. So good.",
    image: "https://images.pexels.com/photos/3997390/pexels-photo-3997390.jpeg",
  },
  {
    title: "No-show. Your schedule safe.",
    subtitle:
      "Set up card capture with online booking. Charge clients if they don’t show. Protect your time and your money.",
    image: "https://images.pexels.com/photos/6135675/pexels-photo-6135675.jpeg",
  },
];

const ThirdNail = () => {
  return (
    <div className="bg-dry py-20 px-4">
      <div className="max-w-7xl mx-auto text-center mb-16">
        <h2 className="text-4xl md:text-5xl font-semibold text-text mb-4">
          Say no to no-shows. Yes please.
        </h2>
        <p className="text-textGray text-lg max-w-3xl mx-auto">
          Reduce no-shows. Stay on top of cash flow. This is nail salon point of
          sale software designed for you.
        </p>
      </div>

      <div className="max-w-7xl mx-auto">
        <Swiper
          pagination={{ clickable: true }}
          spaceBetween={30}
          slidesPerView={1}
          breakpoints={{
            640: { slidesPerView: 1.2 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
            1280: { slidesPerView: 4 },
          }}
        >
          {cardData.map((card, index) => (
            <SwiperSlide key={index}>
              <div className="bg-border text-text rounded-3xl p-8 h-full flex flex-col justify-between shadow-xl">
                <div>
                  <h3 className="text-xl font-semibold whitespace-pre-line mb-4">
                    {card.title}
                  </h3>
                  <p className="text-sm mb-6">{card.subtitle}</p>
                </div>
                <div className="w-full rounded-xl overflow-hidden">
                  <img
                    src={card.image}
                    alt={card.title}
                    className="object-contain mx-auto grayscale"
                  />
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default ThirdNail;
